import React, { useEffect, useState } from "react";
import { ReactComponent as ArrowIcon } from "assets/icons/left-arrow.svg";
import PaymentButton from "./PaymentButton";
import { mercadoPago } from "services/Payments";
import { useMercadopago } from "react-sdk-mercadopago";
import { usePaymentGateway } from "hooks/usePaymentGateway";

const RenderBtnPayment = ({ user, setFormConfig }) => {
  const [mercadoPagoPreferenceId, setMercadoPagoPreferenceId] = useState(null);
  const [errorComponent, setErrorComponent] = useState(null);
  const [loadingOpenPay, setLoadingOpenPay] = useState(false);
  const [loadingMercadoPago, setLoadingMercadoPago] = useState(false);

  const { handleOpenPay } = usePaymentGateway(user, setFormConfig);

  // Initialize MercadoPago SDK
  const mercadopago = useMercadopago.v2(
    process.env.REACT_APP_API_KEY_MERCADOPAGO,
    {
      locale: "es-CO",
    }
  );

  // Fetch the MercadoPago payment preference ID
  const getMercadoPagoId = async () => {
    try {
      setErrorComponent(null);
      setLoadingMercadoPago(true);
      const response = await mercadoPago({
        codigo: user?.codigo,
        contrato: user?.contrato,
        tipo: user?.tipo,
        valor: user?.monto,
      });
      setMercadoPagoPreferenceId(response.data);
    } catch (err) {
      console.error(err);
      setErrorComponent(
        "No se pudo obtener el ID de pago. Intenta nuevamente."
      );
    } finally {
      setLoadingMercadoPago(false);
    }
  };

  // Render the MercadoPago payment button
  useEffect(() => {
    if (mercadoPagoPreferenceId) {
      const container = document.querySelector(".cho-container");
      if (container) {
        mercadopago.checkout({
          preference: {
            id: mercadoPagoPreferenceId,
          },
          autoOpen: true,
          render: {
            container: ".cho-container", // Selector of the button container
            label: "Pagar con MercadoPago",
          },
        });
      } else {
        console.error("El contenedor .cho-container no existe.");
        setErrorComponent("El contenedor de mercado pago no existe.");
      }
    }
  }, [mercadoPagoPreferenceId, mercadopago]);

  const handlePayOpenPay = async () => {
    setLoadingOpenPay(true);
    try {
      await handleOpenPay();
    } catch (error) {
      console.error("OpenPay Error:", error);
      setErrorComponent("Error al procesar el pago con OpenPay.");
    } finally {
      setLoadingOpenPay(false);
    }
  };

  return (
    <div>
      <button
        className="btn-back-step"
        onClick={() => setFormConfig({ step: 4 })}
      >
        <ArrowIcon />
        Regresar
      </button>

      {/* Error message */}
      {errorComponent && (
        <div className="error-message" role="alert">
          {errorComponent}
        </div>
      )}
      {/* MercadoPago payment button */}
      {mercadoPagoPreferenceId && <div className="cho-container" />}

      {user?.url_payU && (
        <a
          href={user?.url_payU}
          target="_blank"
          rel="noopener noreferrer"
          className="btn_payment_payu"
        >
          <img
            src="https://vip.grupoalianzacolombia.com/images/pasarela/payU.png"
            alt="pago payu priority"
          />
        </a>
      )}

      {/* Pagos desde colombia */}
      <section className="container-payments">
        <PaymentButton
          onClick={handlePayOpenPay}
          icon="https://www.openpay.co/_nuxt/img/open-color.bb6186f.svg"
          disabled={loadingOpenPay}
          loading={loadingOpenPay}
          className="open-pay"
          sizeIcon={130}
          addClassDefault={false}
        ></PaymentButton>
        <PaymentButton
          onClick={getMercadoPagoId}
          icon="images/logo/logo-mercado-pago.svg"
          disabled={loadingMercadoPago}
          loading={loadingMercadoPago}
          className="pay-mercado-pago"
          sizeIcon={130}
          addClassDefault={false}
        ></PaymentButton>
      </section>
    </div>
  );
};

export default RenderBtnPayment;
